import React from "react"
import { createBrowserRouter, RouterProvider, Navigate, useLocation } from "react-router-dom"
import Login from "../pages/Auth/Login"
import ResetPassword from "../pages/Auth/ResetPassword"
import Loading from "../pages/layouts/Loading"
import sharedRoutes from "./SharedRoutes"

const LoginRedirect = () => {
    const location = useLocation()
    const redirect = `${location.pathname}${location.search}${location.hash}`

    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />
}

const AuthRoutes = () => {
    const listRoutes = [
        {
            path: "/reset-password",
            element: <ResetPassword />,
            errorElement: <Loading />,
        },
        {
            path: "/login",
            element: <Login />,
            errorElement: <Loading />,
        },
    ]
    listRoutes.push(...sharedRoutes)
    listRoutes.push({
        path: "*",
        element: <LoginRedirect />,
    })

    const router = createBrowserRouter(listRoutes)

    return (
        <RouterProvider router={router} />
    )
}

export default AuthRoutes
